import React, { useEffect, useState } from "react";
import "./Exhibition.css";
import { Button, Modal, Pagination, Table, message, Form, Image, Empty } from "antd";
import { get, post } from "../../apiService";
import moment from "moment";
import "react-quill/dist/quill.snow.css"; // import styles for react-quill
import TitleComp from "./TitleComp";
import { FaTrashAlt } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import UploadFileModal from "./Model/UploadFileModal";
import UpdateFileModal from "./Model/UpdateFileModal";
const { confirm } = Modal;

export default function GalleryControl() {
  const [allquote, setAllQuote] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const columns = [
    {
      title: "Image",
      dataIndex: "file_path",
      key: "file_path",
      render: (image, record) =>
        record.type === "Image" ? (
          <Image
            src={image}
            alt={record.name}
            style={{ width: "100px", height: "auto" }}
          />
        ) : (
          <Button
            icon={<FaEye />}
            target="_blank"
            href={image}
            className="bg-dark text-white"
          >
            Preview Video
          </Button>
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => moment(created_at).format("llll"),
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <UpdateFileModal
            valueData={record}
            fetchData={fetchData}
            pagination={pagination}
          />
          <Button
            className="bg-danger text-white"
            onClick={() => showDeleteConfirm(record.id)}
          >
            <FaTrashAlt />
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [searchInput]);

  const fetchData = async (current, pageSize, search) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/gallery.php?limit=${pageSize}&page=${current}&action=${action}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setAllQuote(response?.message?.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response?.message?.total,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure you want to delete this file?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => handleDelete(id),
    });
  };

  const handleDelete = async (id) => {
    try {
      if (window.confirm("Are you sure want to delete file ?")) {
        const formData = new FormData();
        // exibition_id
        formData.append("id", id);
        formData.append("action", "delete");
        const response = await post("/gallery.php", formData);

        if (response) {
          message.success("File deleted successfully");
          fetchData(pagination.current, pagination.pageSize);
        } else {
          message.error("Failed to delete file");
        }
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while deleting the blog");
    }
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    if (pageSize !== pagination.pageSize) {
      fetchData(1, pageSize);
    } else {
      fetchData(current, pageSize);
    }
  };

  return (
    <div className="p-3">
      <TitleComp
        name="Gallery List"
        button={
          <UploadFileModal fetchData={fetchData} pagination={pagination} />
        }
        type="Gallery"
        totalData={pagination.total}
        setSearchInput={setSearchInput}
      />

      {/* Table for larger screens */}
      <div className="quotation-table">
        <Table
          columns={columns}
          dataSource={allquote}
          pagination={false}
          loading={loading}
          onChange={handleTableChange}
        />
      </div>

      {/* Cards for smaller screens */}
      <div className="quotation-cards">
        {allquote?.length > 0 ? allquote?.map((quote) => (
          <div className="quotation-card" key={quote.exibition_id}>
            {quote.type === "Image" ? (
              <img
                src={quote.file_path}
                alt={quote.name}
                style={{ width: "100px", height: "auto" }}
              />
            ) : (
              <Button
                icon={<FaEye />}
                target="_blank"
                href={quote.file_path}
                className="bg-dark text-white"
              >
                Preview Video
              </Button>
            )}
            <p>
              <strong>Name:</strong> {quote.name}
            </p>
            <p>
              <strong>Type:</strong> {quote.type}
            </p>
            <p>
              <strong>Created At:</strong>{" "}
              {moment(quote.created_at).format("llll")}
            </p>

            <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
              <UpdateFileModal
                valueData={quote}
                fetchData={fetchData}
                pagination={pagination}
              />
              <Button
                className="bg-danger text-white"
                onClick={() => handleDelete(quote.id)}
              >
                <FaTrashAlt />
              </Button>
            </div>
          </div>
        )) : <Empty />}
      </div>

      <Pagination
        className="mt-4"
        current={pagination.current}
        onChange={(page) =>
          setPagination((prev) => ({ ...prev, current: page }))
        }
        total={pagination.total}
      />
    </div>
  );
}
